import React from 'react'


export default function HeaderWithImage({title, src}){

return (

<div className='imageHeader' style={{backgroundImage: "url('https://attractionsbase.com/"+ src +"')"}}>

<span className='imageHeaderTitle'>{title}</span>



</div>


)



}